import { combineReducers } from 'redux';

import fieldErrorsReducer from 'lib/src/redux/reducers/fieldErrors';
import redirectsReducer from 'lib/src/redux/reducers/redirects';
import darkModeReducer from 'lib/src/redux/reducers/darkMode';
import authReducer from './auth';
import adminUsersReducer from './adminUsers';
import superAdminUsersReducer from './superAdminUsers';
import usersReducer from './users';
import challengeTagsReducer from './challengeTags';
import challengeGroupsReducer from './challengeGroups';
import contactUsMessagesReducer from './contactUsMessages';
import challengesReducer from './challenges';

import assessmentChallengesReducer from './assessmentChallenges';
import submissionsReducer from './submissions';
import assessmentsReducer from './assessments';
import organisationsReducer from './organisation';
import calendarReducer from './calendar';

const rootReducer = combineReducers({
    fieldErrorsReducer,
    authReducer,
    adminUsersReducer,
    usersReducer,
    redirectsReducer,
    darkModeReducer,
    superAdminUsersReducer,
    challengeTagsReducer,
    challengeGroupsReducer,
    contactUsMessagesReducer,
    challengesReducer,
    assessmentChallengesReducer,
    submissionsReducer,
    assessmentsReducer,
    organisationsReducer,
    calendarReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
